module.exports = __webpack_public_path__ + "img/analysis-overview.0129da6e.svg";